export const webhook = {
  field: {
    url: 'URI',
    type: 'Type'
  },
  
  button: {
    create: 'Create webhook',
    disabled: 'The entire webhook was created'
  },

  input: {
    disabled: 'The entire webhook was created'
  },

  modal: {
    create: 'Create webhook',
    edit: 'Edit webhook',
    remove: {
      content: 'Are you sure you want to delete the webhook {type}?'
    }
  },

  webhook_type: {
    call_interrupted: 'Call interrupted',
    op_disconnected: 'Operator disconnected',
    op_active: 'Operator active',
    op_inactive: 'Operator inactive',
    call_restored: 'Call restored',
    call_started: 'Call started',
    call_client_answered: 'Call client answered',
    call_failed: 'Call failed',
    call_finished: 'Call finished',
    task_success: 'Task success',
    task_failed: 'Task failed',
    recording_ready: 'Recording ready',
    op_deactivating: 'Operator deactivating',
    call_connected: 'Call connected',
    op_connected: 'Operator connected',
    amd_result: 'Answering machine detection'
  }
}